module.exports = __webpack_public_path__ + "static/media/ok.0da90c83.svg";